// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3mZhC","title":"InfoRow_title__3TvZQ"};